import { navItems } from '@/mocks/filmData';

export default function SiteFooter() {
  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="px-5 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center">
                <i className="ri-film-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-bold text-lg">善良的小姨子在线</span>
            </div>
            <p className="mt-4 text-sm text-background-200 leading-relaxed max-w-md">
              本站是一份围绕《善良的小姨子》语言版本整理的资料型单页，聚焦中文字幕、字幕在线、中文版、国语、中字与双语等方向，
              帮助读者理解不同版本之间的差别，并找到适合自己的观看方式。
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="font-heading font-semibold text-base">页面导航</p>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 gap-x-4">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      jump(item.id);
                    }}
                    className="text-sm text-background-200 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-heading font-semibold text-base">内容说明</p>
            <ul className="mt-4 space-y-2 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5" aria-hidden="true"></i>
                <span>信息以语言版本说明为准</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5" aria-hidden="true"></i>
                <span>不提供具体观看来源</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-translate-2 mt-0.5" aria-hidden="true"></i>
                <span>版本差异请以实际内容为准</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-200">
            © {new Date().getFullYear()} 善良的小姨子在线 · 语言版本信息整理
          </p>
          <p className="text-xs text-background-200">
            本站内容仅用于字幕与译制版本信息说明
          </p>
        </div>
      </div>
    </footer>
  );
}